/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type chat_user = {|
  +createdDate: ?string;
  +isVerifiedTrade: ?boolean;
  +hasVipPermission: ?boolean;
  +profile: ?{|
    +email: ?string;
    +firstName: ?string;
    +lastName: ?string;
  |};
  +roles: ?{|
    +roleList: ?$ReadOnlyArray<?{|
      +name: ?string;
      +createdDate: ?string;
      +userData: ?{|
        +userStatus: ?{|
          +name: ?string;
        |};
      |};
    |}>;
  |};
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "chat_user",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "createdDate",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": "hasVipPermission",
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "B_VIP_CHECKOUT",
          "type": "String!"
        }
      ],
      "name": "hasPermission",
      "storageKey": "hasPermission{\"name\":\"B_VIP_CHECKOUT\"}"
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "Profile",
      "name": "profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "email",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "firstName",
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "lastName",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "UserRoles",
      "name": "roles",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Role",
          "name": "roleList",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "createdDate",
              "storageKey": null
            },
            {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "UserRoleData",
              "name": "userData",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "args": null,
                  "concreteType": "UserRoleUserData",
                  "name": "userStatus",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "args": null,
                      "name": "name",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "User"
};

module.exports = fragment;
